import CustomerServiceForm from './customer-service-form';

function init() {
  CustomerServiceForm.init();
}

export { init };
